<template>
    <div class="equipment_library_wrap">
        <div class="header">
            <el-col :span="19">
                <a
                    :href="exportUrl"
                    target="_blank"
                    download="学校列表"
                >
                    <el-button
                        type="primary"
                        size="medium"
                    >导出
                    </el-button>
                </a>
            </el-col>
            <el-col :span="5">
                <el-input
                    size="medium"
                    placeholder="请输入学校名称或id"
                    v-model.trim="listQuery.schoolName"
                    @change="handleFilter"
                >
                    <el-button
                        size="medium"
                        slot="append"
                        icon="el-icon-search"
                        @click="handleFilter"
                    ></el-button>
                </el-input>
            </el-col>
        </div>
        <el-table
            stripe
            :data="dataList"
            :height="`${windowHeight - 210}px`"
            border
            style="width: 100%"
        >
            <el-table-column
                label="学校id"
                prop="schoolId"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                label="学校名称"
                align="center"
                show-overflow-tooltip
            >
                <template slot-scope="scope">
                    <span class="link-type" @click="jumpToPage('deviceAccountingBySchool', {schoolId: scope.row.schoolId})">{{scope.row.schoolName}}</span>
                </template>
            </el-table-column>
            <el-table-column
                :label="item.equipTypeName"
                v-for="(item, index) in typeList"
                align="center"
            >
                <template slot-scope="scope">
                    {{scope.row.equipmentCountList[index] ? scope.row.equipmentCountList[index] : ''}}
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            class="pagination-container"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="listQuery.pageNo"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="listQuery.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
        >
        </el-pagination>

    </div>
</template>

<script>
    import {
        getEquipmentLibrarySchoolStaticList,
    } from "@/api/equipmentLibrary";
    import {getExportUrl} from '@/utils/utils';
    import windowResize from "@/mixins/windowResize";

    export default {
        name: "deviceAccounting",
        data() {
            return {
                listQuery: {
                    pageNo: 1,
                    pageSize: 20,
                    schoolName: '',
                },
                dataList: [],
                total: null,
                typeList: [],
            };
        },
        filters: {
            timeFormat(time) {
                return time ? time.substring(0, 19) : "--";
            },
        },
        created() {
            this.getList();
        },
        computed: {
            exportUrl() {
                return getExportUrl('wxcepClient1/structure/scancodeEquipment/exportEquipmentLibrarySchoolStaticList', {
                    schoolName: this.listQuery.schoolName
                });
            }
        },
        mixins: [windowResize],
        methods: {
            //获取列表
            getList() {
                getEquipmentLibrarySchoolStaticList(this.listQuery)
                    .then((res) => res.data)
                    .then((data) => {
                        this.typeList = data.data.titleList || [];
                        this.dataList = data.data.dataList;
                        this.total = data.data.pagination.total;
                    })
                    .catch((err) => {
                    });
            },
            //搜索
            handleFilter() {
                this.listQuery.pageNo = 1;
                this.getList();
            },
            //切换码数
            handleSizeChange(val) {
                this.listQuery.pageNo = 1;
                this.listQuery.pageSize = val;
                this.getList();
            },
            //切换页数
            handleCurrentChange(val) {
                this.listQuery.pageNo = val;
                this.getList();
            },
            jumpToPage(path, query = {}) {
                this.$router.push({
                    path,
                    query
                })
            }
        },
    };
</script>

<style lang="scss" scoped>
    .link-type{
        cursor: pointer;
        color: #409eff;
    }
    .equipment_library_wrap {
        padding: 12px;

        .header {
            padding-bottom: 10px;
            overflow: hidden;
        }

        .el-select {
            width: 150px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/hardwareManage/deviceAccounting.vue